export default __webpack_public_path__ + "static/Entenda0089-fd134539f0378693fb628aa2d2572db2.jpg";